import { Component } from '@angular/core';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NavigationService } from '../../services/navigation/navigation.service';
import { TileMessageDashboard } from '../../interfaces/TileMessageDashboard';
import { SharedModule } from '../../modules/shared/shared.module';
import { SharedService } from '../../services/shared/shared.service';
import { SignalService } from 'app/services/signal/signal.service';

@Component({
    selector: 'app-home',
    standalone: true,
    templateUrl: 'home.component.html',
    styleUrl: 'home.component.css',
    imports: [MatProgressSpinnerModule, SharedModule]
})

export class HomeComponent
{
    nb_clos = this.signalService.getSignal("nb_clos")
    nb_en_cours = this.signalService.getSignal("nb_en_cours")
    nb_message_non_lus = this.signalService.getSignal("nb_message_non_lus")
    nb_document_non_lus = this.signalService.getSignal("nb_document_non_lus")
    derniers_messages: TileMessageDashboard[] = []
    id_user!:number

    constructor
    (
        private dashboardService: DashboardService,
        private navigationService: NavigationService,
        private sharedService: SharedService,
        private signalService: SignalService,
    ) 
    {
        this.id_user = this.sharedService.getIdUser()
    }

    ngOnInit()
    {
        this.getData()
    }

    getData()
    {
        this.getLastMessages()
    }

    getLastMessages()
    {
        this.dashboardService.getLastMessages(this.id_user).subscribe(data => {
            if(data) this.derniers_messages = data
        })
    }

    goToMessage(ref:string, id_dossier:number)
    {
        localStorage.setItem("tab", "messages")
        this.navigationService.navigateTo(`dossiers/details/ref_${ref}/id_dossier_${id_dossier}`, [null])
    }

    goToMessageNonLus()
    {
        this.navigationService.navigateTo(`tableau-de-bord/messages-non-lus`, [null])
    }

    goToDossiersEnCours()
    {
        this.navigationService.navigateTo(`tableau-de-bord/dossiers-en-cours`, [null])
    }

    goToDossiersClos()
    {
        this.navigationService.navigateTo(`tableau-de-bord/dossiers-clos`, [null])
    }

    goToDocumentNonLus()
    {
        this.navigationService.navigateTo(`tableau-de-bord/documents-non-consultes`, [null])
    }

    goToProfil()
    {
        this.navigationService.navigateTo(`profil`, [null])
    }
}